var map = {
	"./banner": 10,
	"./banner-text": 11,
	"./banner-text.svg": 11,
	"./banner.jpg": 10,
	"./beauty": 3,
	"./beauty-logo": 12,
	"./beauty-logo.svg": 12,
	"./beauty-word": 13,
	"./beauty-word.svg": 13,
	"./beauty.jpg": 56,
	"./beauty.svg": 3,
	"./dermalogica": 14,
	"./dermalogica.svg": 14,
	"./facebook": 15,
	"./facebook-copper": 16,
	"./facebook-copper.svg": 16,
	"./facebook-image": 17,
	"./facebook-image.png": 17,
	"./facebook.svg": 15,
	"./favicon": 18,
	"./favicon.png": 18,
	"./gift-voucher": 19,
	"./gift-voucher-background": 20,
	"./gift-voucher-background.jpg": 20,
	"./gift-voucher.png": 19,
	"./header-beauty": 4,
	"./header-beauty.png": 4,
	"./header-beauty.svg": 57,
	"./header-salon": 5,
	"./header-salon.png": 5,
	"./header-salon.svg": 58,
	"./instagram": 6,
	"./instagram-copper": 21,
	"./instagram-copper.svg": 21,
	"./instagram-grid": 22,
	"./instagram-grid.png": 22,
	"./instagram.jpg": 59,
	"./instagram.svg": 6,
	"./large-beauty-word": 23,
	"./large-beauty-word.svg": 23,
	"./large-salon-word": 24,
	"./large-salon-word.svg": 24,
	"./logo": 25,
	"./logo.svg": 25,
	"./map": 26,
	"./map.png": 26,
	"./marble": 27,
	"./marble-background": 28,
	"./marble-background.jpg": 28,
	"./marble-grey": 29,
	"./marble-grey.png": 29,
	"./marble-pink": 30,
	"./marble-pink.jpg": 30,
	"./marble.jpg": 27,
	"./photo-frame": 31,
	"./photo-frame-alt": 32,
	"./photo-frame-alt.png": 32,
	"./photo-frame.png": 31,
	"./salon": 7,
	"./salon-frame": 8,
	"./salon-frame.jpg": 60,
	"./salon-frame.svg": 8,
	"./salon-logo": 33,
	"./salon-logo.svg": 33,
	"./salon-mobile": 34,
	"./salon-mobile.png": 34,
	"./salon-word": 35,
	"./salon-word.svg": 35,
	"./salon.jpg": 61,
	"./salon.svg": 7,
	"./team": 36,
	"./team.jpg": 36,
	"./the-uber-logo": 37,
	"./the-uber-logo.svg": 37,
	"./voucher": 38,
	"./voucher.png": 38,
	"./welcome-burger": 39,
	"./welcome-burger.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;